const env = "prod";
// dev 开发环境 uat 测试环境 prod 正式环境

const config = {
  dev: {
    SERVER_URL: '/api/api/',
    // MEDIA_URL: '/api/',
    MEDIA_URL: 'https://wn9zr52qr3.oss-cn-beijing.aliyuncs.com/',
    SOCKET_URL: 'ws://192.168.3.98:8900/websocket/'
  },
  uat: {
    SERVER_URL: '/uat_ucc_v/v_api/api/',
    // MEDIA_URL: '/uat_ucc_v/v_api/',
    MEDIA_URL: 'https://wn9zr52qr3.oss-cn-beijing.aliyuncs.com/',
    SOCKET_URL: 'ws://47.94.52.18/uat_ucc/api/websocket/'
  },
  prod: {
    SERVER_URL: '/microstation/api/',
    MEDIA_URL: 'https://understand-china.oss-cn-beijing.aliyuncs.com/',
    SOCKET_URL: 'ws://39.107.236.123/system/api/websocket/'
  }
}
const defaultConfig = {
  TITLE: 'routeTitle.understandChina',
  // LOGO: require('@/assets/images/logo.png'),
  // AVATAR: require('@/assets/images/default/avatar.png'),
  COOKIES_TOKEN_KEY: 'UCC_V_SITE_TOKEN',
  JWT_TOKEN_BEAR: 'uccVSiteToken ',
  DEFAULT_UPLOAD_SIZE: 5
}

export const COMMON = Object.assign({}, defaultConfig, config[env])
